import React, { useState } from 'react'
import { Divider, Modal, Icon, List, Grid, Accordion } from 'semantic-ui-react'
import PropTypes from "prop-types";
import SearchList from './searchlist';
import { mapPath } from './utils'
import { useTextResources } from '../../language'

//Menu items that IDs have a speical item
const icontypes = {
    33: {
        icon: "icon-file",
        color: "#38bbf7"
    },
    39: {
        icon: "icon-masculine-avatar-user-with-suit",
        color: "#cf1b58"
    },
    44: {
        icon: "icon-calendar",
        color: "#01A7BD"
    },
    50: {
        icon: "icon-currency-exchange",
        color: "#8BC34A"
    },
    53: {
        color: "#8BC34A"
    },
    190: {
        icon: "icon-settings-52",
        color: "#8b239d"
    }
}

//Settings accordion most right menu has multiple "parent" menus
const inlastcolumn = [53, 183, 187]
const MenuPopup = ({ menu, settings, reports, search, open, onClose }) => {

    const text = useTextResources();

    //Is the settings accordion open?
    const [showSettings, setShowSettings] = useState(false)
    const [showReports, setShowReports] = useState(false)

    //Shows a signel parent menu with direct children
    const MenuList = ({ list, menuitems }) => {
        return (
            <List link>
                <List.Header style={{ color: icontypes[list.Id] ? icontypes[list.Id].color : "" }}>{list.Name}</List.Header>
                {
                    menuitems.filter(x => x.ParentId === list.Id).map(subitem => {
                        return (
                            <List.Item key={subitem.Id} href={mapPath(subitem.ViewPath)}>
                                {subitem.Name}
                            </List.Item>
                        )
                    })
                }
            </List>
        )
    }
    MenuList.propTypes = {
        list: PropTypes.object,
        menuitems: PropTypes.array
    }

    return (
        <Modal id="menupopup" closeIcon size="large" open={open} onClose={() => onClose()}>

            {/* popup header */}
            <Modal.Header>
                Optima Menu
                <div style={{ position: "absolute", right: "1em", top: "1em", fontWeight: "initial", fontSize: "initial" }}>
                    <SearchList items={search} />
                </div>
            </Modal.Header>
            <Modal.Content style={{ maxHeight: 760, overflow: "auto" }}>
                {menu &&
                    <React.Fragment>
                        <Grid columns="equal">
                            {
                                menu.filter(item => !inlastcolumn.includes(item.Id) && !item.ParentId && menu.filter(i => i.ParentId === item.Id).length > 0).map((item, index, collection) => {
                                    return (
                                        <Grid.Column key={item.Id}>
                                            <Icon size="huge" className={icontypes[item.Id]?.icon} style={{ color: icontypes[item.Id]?.color }} />
                                            <MenuList list={item} menuitems={menu} />
                                            {
                                                (index === collection.length - 1) && <div>
                                                    {
                                                        menu.filter(item => inlastcolumn.includes(item.Id)).map(item => {
                                                            return (
                                                                <div key={item.Id}>
                                                                    <MenuList list={item} menuitems={menu} />
                                                                </div>
                                                            )
                                                        })
                                                    }

                                                </div>

                                            }
                                        </Grid.Column>
                                    )
                                })
                            }
                        </Grid>
                        <div style={{ height: '1em' }}></div>

                        {/* settings accordion */}
                        <Accordion fluid styled>
                            <Accordion.Title active={showSettings} onClick={() => setShowSettings(!showSettings)}>
                                <Icon name='dropdown' />
                                Settings
                            </Accordion.Title>
                            <Accordion.Content active={showSettings}>
                                <Grid columns="equal">
                                    {
                                        settings.filter(item => !inlastcolumn.includes(item.Id) && !item.ParentId).map((item, index, collection) => {
                                            return (
                                                <Grid.Column key={item.Id}>
                                                    <MenuList list={item} menuitems={settings} />
                                                    {
                                                        (index === collection.length - 1) && <div>
                                                            {
                                                                settings.filter(item => inlastcolumn.includes(item.Id)).map(item => {
                                                                    return <MenuList key={item.Id} list={item} menuitems={settings} />
                                                                })
                                                            }
                                                        </div>

                                                    }
                                                </Grid.Column>
                                            )
                                        })
                                    }
                                </Grid>
                            </Accordion.Content>
                        </Accordion>

                        <Divider hidden />

                        {/* reports accordion */}
                        <Accordion fluid styled>
                            <Accordion.Title active={showReports} onClick={() => setShowReports(!showReports)}>
                                <Icon name='dropdown' />
                                {text('Reports')}
                            </Accordion.Title>
                            <Accordion.Content active={showReports}>
                                <Grid columns="equal">
                                    {
                                        reports.filter(x => !x.ParentId).map(item => {
                                            return (
                                                <Grid.Column key={item.Id}>
                                                    <MenuList list={item} menuitems={reports} />
                                                </Grid.Column>
                                            )
                                        })
                                    }
                                </Grid>
                            </Accordion.Content>
                        </Accordion>
                    </React.Fragment>
                }
            </Modal.Content>
        </Modal>
    )
}
MenuPopup.propTypes = {
    menu: PropTypes.array,
    settings: PropTypes.array,
    reports: PropTypes.array,
    search: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func
}
export default MenuPopup;